import { useMemo } from 'react';
import { useHasPermission } from './useHasPermission';
import { navbarItems } from 'utils/navbar/navbarItems';
import { useStoreState } from 'providers/StoreStateContext';

export const useFirstAccessibleChildPath = (parentPath: string): string | null => {
  const { applicationSettings } = useStoreState();
  const hasPermission = useHasPermission();

  return useMemo(() => {
    const allNavbarItems = navbarItems(
      false,
      applicationSettings?.extensionContract
    );

    const parentItem = allNavbarItems.find(item => item.path === parentPath);
    
    if (!parentItem?.children) {
      return null;
    }

    for (const child of parentItem.children) {
      if (!child.permissionNames || child.permissionNames.length === 0) {
        return child.path;
      }

       const hasAnyPermission = child.permissionNames.some(permission =>
         hasPermission(permission, 0)
       );

      if (hasAnyPermission) {
        return child.path;
      }
    }

    return null;
  }, [parentPath, hasPermission, applicationSettings?.extensionContract]);
};
